// extracted by mini-css-extract-plugin
export var container = "component-module--container--12A0g";
export var text = "component-module--text--1zqwN";
export var bonus = "component-module--bonus--5XeBZ";
export var overall = "component-module--overall--1fTMB";